import React from 'react'

import Layout from '../components/layout'

export default () => (
  <Layout>

	  <h2>Services</h2>


		<h3>Data science and machine learning contracting</h3>

		<p>Hands on data science and machine learning work, finding insights and making predictions from data, designing, researching and building data products and features for your business.</p>


	  <h3>Data strategy consultancy</h3>

		<p>Discover, understand and prioritise emerging opportunities, find new sources of value and defensible, strategic advantages.</p>

		<p>Deliverables include a presentation tailored to your organisation and sector, advisory sessions with your executive team, and a prioritised list of high impact data science projects.</p>


		<h3>Data science consultancy</h3>

		<p>Plan the technical execution of a project, understand data, technical, team and wider product requirements for success.</p>

		<p>Deliverables include architecture plans for a complete data product and pipeline with a flexible roadmap showing times and costs of various feature combinations and team recommendations, plus advisory sessions with your executive and technical team.</p>


		<h3>Data communication</h3>

		<p>Presentations, visualisations and interactive data exploration tools to communicate the value, insight and opportunity in your data and strategy to your investors, board, team and customers.</p>

  </Layout>
)